import styled from 'styled-components';

import { blackPearl, tangaroa } from '@paradigm/design-system/src/colors';

import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import RfqFilterButton from '#/components/UnifiedRfqs/rfq-filters/RfqFilterButton';
import OpenRfqBuilderButton from '#/components/UnifiedRfqs/rfq-builder/OpenRfqBuilderButton';
import RfqTabs from '#/components/UnifiedRfqs/tabs/RfqTabs';
import BatchKillQuoteActions from '#/components/UnifiedRfqs/rfqs/batch-kill/BatchKillQuoteActions';
import ParadexMarketsBanner from '#/components/UnifiedRfqs/components/ParadexMarketsBanner/ParadexMarketsBanner';

import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';

export default function PageActionHeader() {
  const isMobile = useIsMobile();

  return (
    <div>
      <RfqTabs />
      <Header>
        <ActionButtonsContainer>
          {!isMobile && <OpenRfqBuilderButton />}
          <RfqFilterButton />
          <ParadexMarketsBanner />
          <BatchKillContainer>
            <BatchKillQuoteActions />
          </BatchKillContainer>
        </ActionButtonsContainer>
      </Header>
    </div>
  );
}

const Header = styled.div`
  align-items: center;
  display: flex;
  padding: 12px 24px 12px 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    background-color: ${tangaroa};
    padding: 0.75rem 1rem;
  }
`;
const ActionButtonsContainer = styled.div`
  display: grid;
  align-items: center;
  gap: 16px;
  grid-template-columns: max-content max-content max-content 1fr;
  grid-auto-flow: column;
  width: 100%;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: max-content 1fr;
  }
`;
const BatchKillContainer = styled.div`
  height: 30px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
  border-radius: 3px;
  width: 100%;
  background-color: ${blackPearl};
  padding: 0 8px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    background-color: transparent;
    padding: 0;
  }
`;
